/**
 * Table 的選取是單選或複選。
 */
export enum TableSelectionMode {
  SINGLE = 'single',
  MULTIPLE = 'multiple'
}
